import { createContext } from "react";

export const CommonDataContext = createContext({
  isDealerUser: false,
  isLenderUser: false,
  isCommonPartner: false,
});
